import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import {
    EXTRA_LARGE,
    LARGE,
    LARGE_SHORT,
    MEDIUM,
    MEDIUM_SHORT,
    SMALL,
    SMALL_LONG,
} from 'components/Dashboards/Reporting/reportingConfig';

export const reportSummary: IHashmapItemComponentProps = {
    NoPermissionMessage,
    reportConfig: {
        buttons: {
            narrative: false,
        },
    },
    title: 'Report Summary',
    componentKey: 'reportSummary',
    id: 'reportSummary',
    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
            smallLong: SMALL_LONG,
            mediumShort: MEDIUM_SHORT,
            medium: MEDIUM,
            largeShort: LARGE_SHORT,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: MEDIUM_SHORT,
    },
};
